<template>
    <div class="flex gap-2 items-center flex-wrap relative">
        <div 
            class="flex items-center gap-2 bg-[#FFF] border !border-[#D1D1D1] rounded-full px-2.5 py-1 whitespace-nowrap text-[#171717]" 
            v-for="(filter, index) in filtersToDisplay" 
            :key="filter.title ?? index" 
            :id="`${idPrefix}-filter-listtype-${sanitizeId(filter.title)}`">
            <div class="whitespace-nowrap font-normal text-base">
                {{ filter.title }}
            </div>
            <i :id="`${idPrefix}-filter-listtype-remove-${sanitizeId(filter.title)}`" 
                class="ri-close-large-line cursor-pointer text-[#171717]" 
                @click="emit('remove', filter)">
            </i>
        </div>
        <div class="flex gap-2">
            <a :id="`${idPrefix}-filters-clear-all`" class="!underline underline-offset-4 cursor-pointer !text-[#171717]" @click="emit('clear-all')" v-if="hasFilters">
                {{ $t('catalog.clearAll') }}
            </a>
            <div id="show-more" ref="showMoreRef" class="border-l-2 pl-2 border-l-[#D1D1D1]" @click="toggleShowMore" v-if="exceedsChipsLimit">
                <template v-if="showMore === false">
                    <a :id="`${idPrefix}-filters-show-more`" class="!underline underline-offset-4 cursor-pointer !text-[#171717] mr-1">
                        {{ $t('globalCatalog.showMore') }}
                    </a>
                    <i class="ri-arrow-down-s-line"></i>
                </template>
                <template v-else>
                    <a :id="`${idPrefix}-filters-show-more`" class="!underline underline-offset-4 cursor-pointer !text-[#171717] mr-1">
                        {{ $t('globalCatalog.showLess') }}
                    </a>
                    <i class="ri-arrow-up-s-line"></i>
                </template>
            </div>        
        </div>
    </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';

const props = defineProps({
    // Each filter needs a `title`; any other fields are passed back on `remove`.
    filters: {
        type: Array,
        default: () => []
    },
    idPrefix: {
        type: String,
        required: true
    }
});

const emit = defineEmits(['remove', 'clear-all']);

const showMore = ref(false);
const filterChipsLimit = ref(10);
const showMoreRef = ref(null);

const hasFilters = computed(() => props.filters.length > 0);
const exceedsChipsLimit = computed(() => props.filters.length > filterChipsLimit.value);
const filtersToDisplay = computed(() => showMore.value ? props.filters : props.filters.slice(0, filterChipsLimit.value));

function toggleShowMore() {
    showMore.value = !showMore.value;
}

function sanitizeId(value) {
    if (!value && value !== 0) return 'unknown';
    const str = String(value).trim().toLowerCase();
    return str.split(' ').join('-').replace(/[^a-z0-9\-]/g, '');
}

// Shrink the visible chip count when the "Show more" toggle wraps past the first line.
watch(() => props.filters, () => {
    if (showMoreRef.value?.offsetTop > 50) {
        filterChipsLimit.value -= 1;
    }
});
</script>
